<template lang="pug">
  .preloader.preloader--hide
    .preloader__img
      .preloader__img-color-wr
        .preloader__img-color
</template>

<script>
//import '@/components/common/preloader/preloader.styl';

import EventBus from '@/eventBus';

export default {
  name: 'Preloader',

  components: {},

  data() {
    return {
      firstLoad: true
    }
  },

  created() {
    EventBus.$on('preloaderShow', () => {
      this.$nextTick(() => {
        if(this.firstLoad)  {
          $('.preloader').removeClass('preloader--hide').addClass('preloader--animation');

          this.firstLoad = false;
        }

      });
    });

    EventBus.$on('preloaderHide', () => {
      this.$nextTick(() => {
        setTimeout(() => {
          $('.preloader').addClass('preloader--hide').removeClass('preloader--animation');
          $('.menu-left').removeClass('menu-left--hide');
          $('.page__items').removeClass('page__items--hide');
        }, 1000);
      });
    });
  }
}
</script>
